<template>
  <div class="accordion">
    <header class="accordion__header" :class="{ 'is-open': isOpen }" @click="toggle">
      <h2><slot name="title" /></h2>
      <span class="accordion__icon">›</span>
    </header>
    <transition name="accordion">
      <div v-show="isOpen" class="accordion__body">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
const isOpen = ref(false);
function toggle() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped lang="scss">
.accordion {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  overflow: hidden;
}
.accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #2c3e50;
  padding: 0.75rem 1rem;
  cursor: pointer;
  user-select: none;
  color: white;
}
.accordion__header.is-open .accordion__icon {
  transform: rotate(90deg);
}
.accordion__icon {
  transition: transform 0.3s ease;
}
.accordion__body {
  background: #ffffff;
  padding: 1rem;
}
.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.accordion-enter-to,
.accordion-leave-from {
  max-height: 800px;
  opacity: 1;
}
.accordion-enter-active,
.accordion-leave-active {
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
}
</style>
